const action = "FOUNDATION_BYOM_DOWNLOAD";
export const REQUEST  = action + '_REQUEST';
export const RESPONSE = action + '_RESPONSE';
export const FAILURE  = action + '_FAILURE';
export const CLEAR    = action + '_CLEAR';

// payload: { blueprint_id }
export const fetchRequest = (payload)  => ({ type: REQUEST,  payload });
export const fetchSuccess = (response) => ({ type: RESPONSE, payload: response });
export const fetchFailure = (error)    => ({ type: FAILURE,  payload: error });
export const clearState   = ()         => ({ type: CLEAR });
